export const LOG_PREFIX = '[HrAgreements]';

export const formatLogMessage = (message: string): string => `${LOG_PREFIX} ${message}`;

export const logger = {
  error: (message: string, ...details: unknown[]): void => {
    console.error(formatLogMessage(message), ...details);
  },
  warn: (message: string, ...details: unknown[]): void => {
    console.warn(formatLogMessage(message), ...details);
  },
  info: (message: string, ...details: unknown[]): void => {
    console.info(formatLogMessage(message), ...details);
  },
};
